import type { BadgeColor } from '@odin-labs/components';
import type { DraftTag, Enforcement } from 'siteLayout';

/** What the reader does with a badge on a crossing in this direction. */
export const enforcementLabels: Record<Enforcement, string> = {
  ENFORCED: 'Enforced',
  IDENTIFY_ONLY: 'Recorded',
  NOT_TRACKED: 'None',
};

export const enforcementHelp =
  'Enforced: the reader may deny. Recorded: every crossing is recorded, none denied. None: nothing is recorded in this direction.';

// The seed adds entries only for live gateways with no live link. An entry
// removed in a draft keeps its link until the draft is published or
// discarded. Publishing retires the link (deletes it, with an entry no
// version includes) and soft-deletes the gateway, unless a new entry of its
// name takes it. Discarding the draft that seeded the entry undoes that seed,
// so a later one adds the entry again.
export const seedHelp =
  "An entry added from a gateway isn't added again after you remove it.";

export const draftTagBadge = (
  tag: DraftTag,
): { text: string; color: BadgeColor } | null => {
  if (tag === 'NEW') return { text: 'New', color: 'purple' };
  if (tag === 'CHANGED') return { text: 'Changed', color: 'yellow' };
  return null;
};
